module.exports = {};

$(init);

NLMK.initChart = init;
$(window).on('NLMK.initChart', init);

$(document).ajaxComplete(init);

function init() {
    const $charts = $('.js-chart');

    if ($charts.length) {
        require.ensure(
            ['./module'],
            () => {
                require('./module.js');
            },
            'chart',
        );
    }
}



// WEBPACK FOOTER //
// ./js/main/module/chart/index.js